var map = {
	"./01-Vienna-town-hall/Album/Assets-01-Vienna-Town-Hall-01.png": 51,
	"./01-Vienna-town-hall/Assets-01-Vienna-Town-Hall-halftone.jpg": 52,
	"./01-Vienna-town-hall/Assets-01-Vienna-Town-Hall-hero.jpg": 53,
	"./01-Vienna-town-hall/Videos/Assets-01-Vienna-Town-Hall-02.mp4": 54,
	"./02-HRA/Album/Assets-02-HRA-01.png": 55,
	"./02-HRA/Assets-02-HRA-halftone.png": 56,
	"./02-HRA/Assets-02-HRA-hero.png": 57,
	"./03-VirtualSurgery-exhibition/Assets-03-VirtualSurgery-Exhibition-halftone.jpg": 58,
	"./03-VirtualSurgery-exhibition/Assets-03-VirtualSurgery-Exhibition-hero.jpg": 59,
	"./03-VirtualSurgery-exhibition/Videos/Assets-03-VirtualSurgery-Exhibition-01.mp4": 60,
	"./04-AB-Dental/Album/Assets-04-AB-dental-01.png": 61,
	"./04-AB-Dental/Assets-04-AB-dental-halftone.jpg": 62,
	"./04-AB-Dental/Assets-04-AB-dental-hero.jpg": 63,
	"./05-MNM/Album/Assets-05-MNM-01.png": 64,
	"./05-MNM/Album/Assets-05-MNM-02.png": 65,
	"./05-MNM/Album/Assets-05-MNM-03.png": 66,
	"./05-MNM/Assets-05-MNM-halftone.png": 67,
	"./05-MNM/Assets-05-MNM-hero.png": 68,
	"./06-Books-of-type/Album/Assets-06-Books-of-type-01.png": 69,
	"./06-Books-of-type/Album/Assets-06-Books-of-type-02.png": 70,
	"./06-Books-of-type/Album/Assets-06-Books-of-type-03.png": 71,
	"./06-Books-of-type/Album/Assets-06-Books-of-type-04.png": 72,
	"./06-Books-of-type/Assets-06-Books-of-type-halftone.jpg": 73,
	"./06-Books-of-type/Assets-06-Books-of-type-hero.jpg": 74,
	"./07-Camden-market/Album/Assets-07-Camden-Market-01.png": 75,
	"./07-Camden-market/Album/Assets-07-Camden-Market-02.png": 76,
	"./07-Camden-market/Assets-07-Camden-Market-halftone.jpg": 77,
	"./07-Camden-market/Assets-07-Camden-Market-hero.jpg": 78,
	"./08-Falling-Myth/Album/Assets-08-Visualising-epilepsy-01.png": 79,
	"./08-Falling-Myth/Album/Assets-08-Visualising-epilepsy-02.png": 80,
	"./08-Falling-Myth/Assets-08-Visualising-epilepsy-halftone.jpg": 81,
	"./08-Falling-Myth/Assets-08-Visualising-epilepsy-hero.jpg": 82,
	"./09-Capital/Assets-09-Capital-halftone.jpg": 83,
	"./09-Capital/Assets-09-Capital-hero.jpg": 84,
	"./09-Capital/Videos/Assets-09-Capital-01.mp4": 85,
	"./10-Si-Mayaa/Album/Assets-10-Si-Mayaa-01.png": 86,
	"./10-Si-Mayaa/Album/Assets-10-Si-Mayaa-02.png": 87,
	"./10-Si-Mayaa/Album/Assets-10-Si-Mayaa-03.png": 88,
	"./10-Si-Mayaa/Assets-10-Si-Mayaa-halftone.png": 89,
	"./10-Si-Mayaa/Assets-10-Si-Mayaa-hero.png": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;